import { JOGGResponse } from "@jog/types"

import { JoggApiOption } from "./client"

export const replicateOrderBase =
    ({ execute }: Pick<JoggApiOption, "execute">) =>
    async (orderId: string): Promise<JOGGResponse<{ replicatedCart: string }>> => {
        return execute({
            method: "POST",
            uri: `/ctp/orders/${orderId}/replicate`,
        })
    }
